import React from "react";
import { Icon } from "../core/Icon";

const tones = {
  info: { bg: "var(--surface-trust)", fg: "var(--text-trust)", border: "#C9DBE1", icon: "info" },
  success: { bg: "var(--success-tint)", fg: "var(--success)", border: "#CFE0C6", icon: "check-circle-2" },
  warning: { bg: "var(--warning-tint)", fg: "var(--warning)", border: "#EFD9B8", icon: "alert-triangle" },
  danger: { bg: "var(--danger-tint)", fg: "var(--danger)", border: "#EDCCC7", icon: "alert-circle" },
};

export function Alert({ tone = "info", title, children, onDismiss }) {
  const s = tones[tone];
  return (
    <div role="status" style={{
      display: "flex", gap: "var(--space-3)", padding: "var(--space-4)",
      borderRadius: "var(--radius-md)", background: s.bg,
      border: `1px solid ${s.border}`, color: "var(--text-body)",
    }}>
      <Icon name={s.icon} size={18} style={{ color: s.fg, marginTop: 1 }} />
      <div style={{ flex: 1, minWidth: 0 }}>
        {title && (
          <p style={{ fontFamily: "var(--font-display)", fontWeight: "var(--weight-semibold)", fontSize: "var(--text-sm)", color: s.fg }}>{title}</p>
        )}
        <div style={{ fontSize: "var(--text-sm)", lineHeight: "var(--leading-normal)", color: "var(--text-muted)", marginTop: title ? 2 : 0 }}>
          {children}
        </div>
      </div>
      {onDismiss && (
        <button onClick={onDismiss} aria-label="Dismiss" style={{ border: "none", background: "transparent", cursor: "pointer", color: "var(--text-muted)", padding: 0 }}>
          <Icon name="x" size={16} />
        </button>
      )}
    </div>
  );
}
